import { FilterBase } from "@models/base/filterBase.model";

export class JuzgadoFilter extends FilterBase {
  public id: number | null = null;
  public idsFuero: number[] | null = null;
  public idsJurisdiccion: number[] | null = null;
  public idPais: number | null = null;
  public idLocalidad: number | null = null;
  public nominacion: string | null = null;
  public subnominacion: string | null = null;
  public competencia: string | null = null;
  public grado: string | null = null;
  public numero: string | null = null;
  public letra: string | null = null;
  public esActivo: boolean = false;
  public esSecretaria: boolean = false;
  public tieneMesaVirtual: boolean = false;
  public horarioAtencion: string | null = null;
  public urlSistemaGestion: string | null = null;
  public fechaAltaDesde: Date | null = null;
  public fechaAltaHasta: Date | null = null;
  public fechaModificacionDesde: Date | null = null;
  public fechaModificacionHasta: Date | null = null;
}
